

// PERMISSIONS
export const GET_PERMISSIONS = "/permissions";
export const ADD_NEW_PERMISSION = "/permissions";
export const UPDATE_PERMISSION = "/permissions";
export const DELETE_PERMISSION = "/permissions";
